<template>
  <el-card
    shadow="never"
    class="customer-synopsis"
  >
    <div
      slot="header"
      class="customer-synopsis__header"
    >
      {{ $t('customersLocationsManagement.synopsis.title') }}
    </div>

    <el-descriptions :column="3">
      <el-descriptions-item
        v-for="field in fields"
        :key="field.key"
      >
        <template slot="label">
          <span class="customer-synopsis__label">
            <i :class="field.icon" />
            {{ $t(`customersLocationsManagement.synopsis.${field.key}`) }}
          </span>
        </template>
        <el-tag
          class="customer-synopsis__value"
          :class="{
            'customer-synopsis__value--neutral': field.kind !== 'boolean',
          }"
          :type="tagType(field)"
        >
          {{ display(field) }}
        </el-tag>
      </el-descriptions-item>
    </el-descriptions>
  </el-card>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'CustomerSynopsis',
    props: {
      customer: { type: Object, required: true },
    },
    data() {
      return {
        fields: [
          { key: 'id', icon: 'el-icon-key' },
          { key: 'name', icon: 'el-icon-office-building' },
          { key: 'address', icon: 'el-icon-location-outline' },
          { key: 'city', icon: 'el-icon-map-location' },
          { key: 'zip', icon: 'el-icon-postcard' },
          { key: 'province', icon: 'el-icon-place' },
          { key: 'countryCode', icon: 'el-icon-guide' },
          { key: 'countryDescription', icon: 'el-icon-guide' },
          { key: 'vat', icon: 'el-icon-tickets' },
          { key: 'fiscalCode', icon: 'el-icon-postcard' },
          { key: 'phoneNumber', icon: 'el-icon-phone-outline' },
          { key: 'email', icon: 'el-icon-message' },
          { key: 'isEnabled', icon: 'el-icon-circle-check', kind: 'boolean' },
          { key: 'canViewRawData', icon: 'el-icon-view', kind: 'boolean' },
          { key: 'creditLimit', icon: 'el-icon-coin' },
          { key: 'maxOrder', icon: 'el-icon-shopping-cart-full' },
          {
            key: 'creditLimitExpirationDate',
            icon: 'el-icon-date',
            kind: 'date',
          },
        ],
      };
    },
    methods: {
      // I filtri globali (`sanitizer`, `date`) non sono registrati su localVue
      // nei test, quindi la formattazione vive qui come metodi del componente.
      display(field) {
        const value = this.customer[field.key];
        if (field.kind === 'boolean') {
          return value
            ? this.$t('customersLocationsManagement.synopsis.yes')
            : this.$t('customersLocationsManagement.synopsis.no');
        }
        if (field.kind === 'date') {
          return value ? moment(value).format('DD/MM/YYYY') : '-';
        }
        if (value === null || value === undefined || value === '') return '-';
        return value;
      },
      tagType(field) {
        if (field.kind !== 'boolean') return '';
        return this.customer[field.key] ? 'success' : 'danger';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .customer-synopsis {
    margin-bottom: 1.5rem;
    background-color: $--color-black-lighter;
    border: 1px solid $--border-color-base;

    &__header {
      color: $--color-text-primary;
      font-weight: 600;
    }

    &__label {
      display: inline-flex;
      align-items: center;
      color: $--color-text-regular;

      i[class^='el-icon-'] {
        margin-right: 0.35rem;
      }
    }

    // Solo forma e dimensione: i colori restano quelli del `type` di el-tag,
    // altrimenti la specificità dello scoped (0,2,0) batte .el-tag--success
    // (0,1,0) e i booleani perdono la loro semantica.
    &__value {
      height: auto;
      padding: 4px 10px;
      line-height: 1.5;
      white-space: normal;
      font-size: 0.85rem;
    }

    &__value--neutral {
      background-color: rgba($--color-white, 0.1);
      border-color: rgba($--color-white, 0.18);
      color: $--color-text-primary;
    }

    ::v-deep .el-card__header {
      border-bottom: 1px solid $--border-color-base;
    }

    ::v-deep .el-descriptions__body {
      background-color: transparent;
    }

    ::v-deep .el-descriptions-item__content {
      color: $--color-text-primary;
    }

    ::v-deep .el-descriptions-item__cell {
      padding-bottom: 0.75rem;
    }

    ::v-deep .el-descriptions-item__container {
      align-items: center;

      .el-descriptions-item__label,
      .el-descriptions-item__content {
        align-items: center;
      }
    }
  }
</style>
